var exports = {
  "uW": "PricingSection.module__section___M1V1b2",
  "E3": "PricingSection.module__toggleContainer___M1V1b2",
  "xQ": "PricingSection.module__footerContainer___M1V1b2",
  "$P": "PricingSection.module__scrollPromptContainer___M1V1b2",
  "Zq": "PricingSection.module__scrollPromptText___M1V1b2",
  "$O": "PricingSection.module__scrollPromptIcon___M1V1b2",
};

module.exports = exports;
